module.exports = __webpack_public_path__ + "6e05ce0e.woff";